import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.566.75a1.125 1.125 0 0 1 2.118 0l.82 2.312a1.13 1.13 0 0 0 .684.684l2.314.82a1.125 1.125 0 0 1 0 2.118l-2.314.82a1.13 1.13 0 0 0-.684.684l-.82 2.312a1.125 1.125 0 0 1-2.118 0l-.82-2.314a1.13 1.13 0 0 0-.684-.684L.75 6.684a1.125 1.125 0 0 1 0-2.118l2.314-.82a1.13 1.13 0 0 0 .684-.684zm8.559 2.531a1.406 1.406 0 0 1 1.406-1.406h9.844A5.625 5.625 0 0 1 30 7.5v11.25a5.625 5.625 0 0 1-5.625 5.625H7.618L2.4 29.587a1.407 1.407 0 0 1-2.4-.993V12.656a1.406 1.406 0 0 1 2.813 0V25.2l3.23-3.225.413-.413h17.919a2.81 2.81 0 0 0 2.813-2.812V7.5a2.81 2.81 0 0 0-2.813-2.813h-9.844a1.406 1.406 0 0 1-1.406-1.406m2.756 5.809a.938.938 0 0 0-1.762 0l-.685 1.93a.94.94 0 0 1-.57.57l-1.927.682a.938.938 0 0 0 0 1.764l1.927.685a.94.94 0 0 1 .57.57l.683 1.927a.937.937 0 0 0 1.766 0l.683-1.927a.94.94 0 0 1 .57-.57l1.927-.685a.938.938 0 0 0 0-1.764l-1.925-.684a.94.94 0 0 1-.57-.57l-.683-1.93z",
      "clip-rule": "evenodd"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }